function fetchUser(id, apiUrl, token) {
    return fetch(`${apiUrl}/v1/users/${id}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }).then(res => {
        if (!res.ok)
            throw Error(res.statusText);
        return res.json();
    });
}
export default fetchUser;
//# sourceMappingURL=fetchUser.js.map